import { useQuery } from '@tanstack/react-query';
import { api } from './api';
import type {
  DashboardActivityData,
  DashboardCrmPulseData,
  DashboardFinancialsData,
} from '@/types/api';

export function useDashboardFinancials() {
  return useQuery({
    queryKey: ['dashboard', 'financials'],
    queryFn: async (): Promise<DashboardFinancialsData> => {
      const { data } = await api.get<DashboardFinancialsData>('/v1/dashboard/financials');
      return data;
    },
  });
}

export function useDashboardRecentActivity() {
  return useQuery({
    queryKey: ['dashboard', 'recent-activity'],
    queryFn: async (): Promise<DashboardActivityData[]> => {
      const { data } = await api.get<DashboardActivityData[]>('/v1/dashboard/recent-activity');
      return data;
    },
  });
}

export function useDashboardCrmPulse() {
  return useQuery({
    queryKey: ['dashboard', 'crm-pulse'],
    queryFn: async (): Promise<DashboardCrmPulseData> => {
      const { data } = await api.get<DashboardCrmPulseData>('/v1/dashboard/crm-pulse');
      return data;
    },
  });
}
